import React, { Suspense, lazy } from 'react';
import * as Sentry from '@sentry/react';
import { Route, Switch } from 'react-router-dom';
// import MainApp from './MainApp';
import { retry } from './utils/retry';
import AuthenticationPage from './components/AuthenticationPage/AuthenticationPage';
import LoginPage from './components/LoginPage/LoginPage';
import LogoutPage from './components/LogoutPage/LogoutPage';
import RegisterMandantPage from './components/RegisterMandantPage/RegisterMandantPage';
import RegisterAtMandant from './components/RegisterAtMandant/RegisterAtMandant';
import FullScreenLoading from './elements/FullScreenLoading';
import ErrorPage from './components/ErrorPage/ErrorPage';

const MainApp = lazy(() => retry(() => import('./MainApp')));

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <Suspense fallback={<FullScreenLoading />}>
        <Switch>
          <Route path='/login' component={LoginPage} />
          <Route
            path='/register/at/:mandantRegisterId'
            component={RegisterAtMandant}
          />
          <Route path='/register' component={RegisterMandantPage} />
          <Route path='/authentication' component={AuthenticationPage} />
          <Route exact path='/logout' component={LogoutPage} />
          <Route path='/' component={MainApp} />
        </Switch>
      </Suspense>
    </Sentry.ErrorBoundary>
  );
}

export default App;
